export default () => ({
  projectsList: [],
  projectDetailMap: {},
  totalProjects: 0,
  selectedProject: {},
});
